import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useConsumerAuth } from 'context/ConsumerAuthProvider';

export const RequireConsumerAuth = ({ children }: { children: React.ReactElement }) => {
  const { token } = useConsumerAuth();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/consumer/login" replace state={{ from: location }} />;
  }

  return children;
};

export const RequireConsumerPermission = ({
  moduleKey,
  children,
}: {
  moduleKey: string;
  children: React.ReactElement;
}) => {
  const { hasPermission } = useConsumerAuth();

  if (!hasPermission(moduleKey)) {
    return <Navigate to="/consumer/dashboard" replace />;
  }

  return children;
};
